import React from 'react';

function Consult() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-[#1a4a1a] mb-4">
              Get Expert Financial Guidance
            </h1>
            <p className="text-[#1a4a1a]/90 text-lg md:text-xl font-medium max-w-2xl mx-auto">
              Need assistance with halal loans to grow your business? Our experts are here to help you navigate Islamic financing solutions.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="p-8 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a1a] mb-2">Contact Our Team</h2>
              <p className="text-[#1a4a1a]/90 font-medium mb-8">We're available to discuss your Islamic financing needs</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                <a 
                  href="tel:+14253400980" 
                  className="group flex flex-col items-center gap-4 px-6 py-8 bg-[#1a4a1a]/5 hover:bg-[#1a4a1a]/10 rounded-xl transition-all duration-300 hover:scale-105"
                >
                  <div className="w-16 h-16 rounded-full bg-[#1a4a1a]/10 flex items-center justify-center group-hover:bg-[#1a4a1a]/20 transition-all duration-300">
                    <svg className="w-8 h-8 text-[#1a4a1a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <p className="text-lg text-[#1a4a1a] font-bold">+1-425-340-0980</p>
                    <p className="text-sm text-[#1a4a1a]/85">Mon-Fri, 9am-5pm PST</p>
                  </div>
                </a>

                <a 
                  href="mailto:salaam@halalcred.com" 
                  className="group flex flex-col items-center gap-4 px-6 py-8 bg-[#1a4a1a]/5 hover:bg-[#1a4a1a]/10 rounded-xl transition-all duration-300 hover:scale-105"
                >
                  <div className="w-16 h-16 rounded-full bg-[#1a4a1a]/10 flex items-center justify-center group-hover:bg-[#1a4a1a]/20 transition-all duration-300">
                    <svg className="w-8 h-8 text-[#1a4a1a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <p className="text-lg text-[#1a4a1a] font-bold">salaam@halalcred.com</p>
                    <p className="text-sm text-[#1a4a1a]/85">24hr Response Time</p>
                  </div>
                </a>
              </div>

              <div className="mt-8 pt-8 border-t border-[#1a4a1a]/10">
                <h3 className="text-xl font-semibold text-[#1a4a1a] mb-4">How We Can Help</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto">
                  <div className="bg-[#1a4a1a]/5 p-4 rounded-lg">
                    <h4 className="font-semibold text-[#1a4a1a] mb-2">Need capital to grow your business?</h4>
                    <ul className="text-sm text-[#1a4a1a]/90 space-y-1">
                      <li>• Halal Business Loans</li>
                      <li>• Halal Business Checking & Savings</li>
                      <li>• Halal NonProfit Loans</li>
                      <li>• Halal NonProfit Banking</li>
                    </ul>
                  </div>
                  <div className="bg-[#1a4a1a]/5 p-4 rounded-lg">
                    <h4 className="font-semibold text-[#1a4a1a] mb-2">Need help with other business services?</h4>
                    <div className="text-sm text-[#1a4a1a]/90 space-y-3">
                      <p className="pt-2">
                        While we're building our online platform to list our service providers, you can still get immediate assistance! Call us at <a href="tel:+14253400980" className="font-semibold text-[#1a4a1a] hover:underline">+1-425-340-0980</a> to discuss:
                      </p>
                      <ul className="space-y-1 pl-4">
                        <li>• Tax</li>
                        <li>• Legal Services</li>
                        <li>• UX Design and Development</li>
                        <li>• Website Development</li>
                        <li>• IT support</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Consult;
